(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["diamonds-video"]) return;
  try {
    
    // $(document).ready(function () {
    //     let playIcon = $(".video-pre-icon #play");
    //     let stopIcon = $(".video-pre-icon #stop");
    //     let labVideo = $("#labVideo");
    //     playIcon.on("click", function () {
    //         labVideo.trigger('play');
    //         stopIcon.show();
    //         $(this).hide();
    //     });
    //     stopIcon.on("click", function () {
    //         labVideo.trigger('pause');
    //         playIcon.show();
    //         $(this).hide();
    //     });
    //     labVideo.on("ended", function () {
    //         labVideo.load();
    //         playIcon.show();
    //         stopIcon.hide();
    //     });
    // });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-video"] && !Shopify.designMode) return;
  try {
     
  $(document).ready(function () {
    $(".video_wrapper").on("click", function () {
      $(this).find("video").css({
        'opacity': 1,
        'z-index': 1
      }).trigger('play');
      $(this).find(".video-poster").css("opacity", "0");
    });
  });

  } catch(e) { console.error(e); }
})();
})();
